import {
  AfterViewInit,
  Component,
  ChangeDetectionStrategy,
} from '@angular/core';
import { firstValueFrom, Observable, of, ReplaySubject } from 'rxjs';
import { delay } from 'rxjs/operators';
import { OnLoaded } from '@lyceo/shared/dynamic-component-loading/feature-main';
import {
  QuestionAnswer,
  QuestionControlType,
} from '../question-type.interface';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-unsupported-question',
  templateUrl: './unsupported-question.component.html',
  styleUrls: ['./unsupported-question.component.scss'],
})
export class UnsupportedQuestionComponent
  implements AfterViewInit, OnLoaded, QuestionControlType
{
  /**
   * The question that is presented.
   */
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  public question: any;

  /**
   * Input to prefill the answer of the question.
   */
  public answer: undefined;

  /**
   * Subject which starts to emit when the view is rendered. This is needed because the
   * component is dynamically loading.
   */
  public onFinishedInit$: ReplaySubject<void> = new ReplaySubject<void>();

  /**
   * @inheritDoc
   */
  public ngAfterViewInit(): void {
    this.onFinishedInit$.next();
    this.onFinishedInit$.complete();
  }

  /**
   * @inheritDoc
   */
  public ready(): Promise<void> {
    return firstValueFrom(this.onFinishedInit$.pipe(delay(20)));
  }

  /**
   * @inheritDoc
   */
  public isPristine(): boolean {
    return true;
  }

  /**
   * @inheritDoc
   */
  public getValue(): QuestionAnswer {
    return null as never;
  }

  /**
   * @inheritDoc
   */
  public onValueChanges(): Observable<QuestionAnswer> {
    return of(null) as never as Observable<QuestionAnswer>;
  }

  /**
   * @inheritDoc
   */
  public onValidChanges(): Observable<boolean> {
    return of(true);
  }

  /**
   * @inheritDoc
   */
  public isValid(): boolean {
    return true;
  }
}
